<template>
  <div>
    <el-row>
      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>
    <el-table :data="pageData.items" stripe border height="400" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
      <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
        <template slot-scope="scope">
          <template v-if="it.key === 'device_parameter_value'">
            <template v-if="isControllable">
              <el-input v-if="scope.row.device_parameter.parameter_value_type === 1" v-model="scope.row[it.key]" size="mini" />
              <el-select v-if="scope.row.device_parameter.parameter_value_type === 2" v-model="scope.row[it.key]">
                <el-option
                  v-for="val in scope.row.device_parameter.parameter_input_range.split(',')"
                  :key="val"
                  :label="val"
                  :value="val">
                </el-option>
              </el-select>
            </template>
            <span v-else>{{getRowKeyVal(scope.row, it)}}</span>
          </template>
          <span v-else>{{getRowKeyVal(scope.row, it)}}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="下发操作" v-if="isControllable">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="issue(scope.row)">下发</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    const deviceId = this.rowData.device_id
    const deviceModelId = this.rowData.device_model_id
    const isControllable = this.isControllable
    const parameterType1 = this.parameterTypeList[0]
    const parameterType2 = this.parameterTypeList[1]
    const parameterType3 = this.parameterTypeList[2]

    return Backend.initListPageNoCache(this, 'device_parameter', {
      route_name: '设备参数列表',
      params: {
        device_id: deviceId,
        device_model_id: deviceModelId,
        parameter_type_1: parameterType1,
        parameter_type_2: parameterType2 === undefined ? -1 : parameterType2,
        parameter_type_3: parameterType3 === undefined ? -1 : parameterType3,
        is_controllable: isControllable
      },
      allTableColList: [
        {
          key: 'parameter_id',
          name: '参数ID',
          parent: 'device_parameter',
          fixed: true
        },
        {
          key: 'parameter_name',
          name: '参数名称',
          parent: 'device_parameter'
        },
        {
          key: 'device_parameter_value',
          name: '数值'
        },
        {
          key: 'parameter_input_range',
          type: 'dd',
          name: '建议输入范围',
          parent: 'device_parameter'
        },
        {
          key: 'parameter_unit',
          name: '单位',
          parent: 'device_parameter'
        },
        {
          key: 'parameter_desp',
          name: '参数说明',
          parent: 'device_parameter'
        },
        {
          key: 'report_time',
          type: 'dr',
          name: '更新时间'
        }
      ]
    })
  },

  computed: {
    tableColList () {
      console.log(this.isControllable)
      if (this.isControllable) {
        return this.allTableColList.filter(it => it.type !== 'dr')
      } else {
        return this.allTableColList.filter(it => it.type !== 'dd')
      }
    }
  },

  props: ['rowData', 'isControllable', 'parameterTypeList'],

  watch: {
    parameterTypeList: {
      handler (arr) {
        this.getParameterTypes(arr)
        this.resetTableParams()
        this.onSearch()
      },
      deep: true
    }
  },

  methods: {
    getRowKeyVal (row, it) {
      return it.parent ? (row[it.parent] ? row[it.parent][it.key] : '') : row[it.key]
    },
    getParameterTypes (arr) {
      for (let i = 0; i < 3; i++) {
        this.params[`parameter_type_${i + 1}`] = arr[i] === undefined ? -1 : arr[i]
      }
    },
    resetTableParams () {
      this.pageData.filter = ''
      this.pageData.first = -1
      this.pageData.items = []
      this.params.max_results = this.pageData.max_results = 10
      this.pageData.page = 0
      this.pageData.total = 0
    },
    issue (row) {
      if (row.device_parameter.parameter_value_type === 1) {
        const val_ = row.device_parameter_value
        if (!val_.trim()) {
          this.$message.error('下发数值不能为空!')
          return
        }
        if (isNaN(val_ - 0) || (val_.startsWith('0') && !val_.startsWith('0.') && val_ !== '0') || val_ - 0 < 0) {
          this.$message.error('下发数值只支持输入包括0的正数!')
          return
        }
      }
      const params = { device_id: this.rowData.device_id, device_parameter_id: row.device_parameter_id, device_model_parameter_id: row.device_model_parameter_id, operate_content: row.device_parameter_value }
      Backend.post(this, 'device_parameter_operate_recorder/set_parameter_value', params).then((res) => {
        this.$message.success('下发成功!')
      })
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0, this.params)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-row{
    height: 34px;
  }
</style>
